import { useEffect, useRef } from "react"
import { getCable } from "../../../shared/api/cable"

export const useChatRoomSocket = ({
  chatType,
  chatId,
  onMessage,
  onReadStatus,
  onDepartmentChange,
  onPresence,
}) => {
  const handlersRef = useRef({ onMessage, onReadStatus, onDepartmentChange, onPresence })
  handlersRef.current = { onMessage, onReadStatus, onDepartmentChange, onPresence }

  useEffect(() => {
    if (!chatId) return

    const cable = getCable()
    const subscription = cable.subscriptions.create(
      { channel: "ChatRoomChannel", chat_type: chatType, chat_id: chatId },
      {
        received(data) {
          const { onMessage, onReadStatus, onDepartmentChange, onPresence } = handlersRef.current
          switch (data.type) {
            case "new_message":
              onMessage?.(data)
              break
            case "read_status":
              onReadStatus?.(data)
              break
            case "department_change":
              onDepartmentChange?.(data)
              break
            case "presence":
              onPresence?.(data)
              break
          }
        },
      }
    )

    return () => subscription.unsubscribe()
  }, [chatType, chatId])
}

export default useChatRoomSocket
